/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import remove from '../../../../../Res/Icon/remove.png';
import './BoxObi.css';
import { unAssignAta } from '../../../../../actions/EpikBoxes';

const ExternalAta = props => {
  const token = localStorage.getItem('jwtToken') || null;

  const { selected, active, enableBoxEdit, box, boxTrigger } = props;
  const dispatch = useDispatch();
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  const containerClassName = selected ? 'boxObiContainer selected' : 'boxObiContainer';

  const onExternalAtaRemove = async () => {
    const externalId = boxDetails?.externalAta[0]._id;
    const result = await dispatch(unAssignAta(token, externalId));
    if (result) {
      boxTrigger(true);
    }
  };
  const activeBtnStyle = {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
  };
  return (
    <div className={containerClassName} onClick={() => null}>
      <div className="d-flex justify-content-between align-items-center w-100">
        <div
          style={{
            paddingLeft: '5px',
          }}
        >
          {active ? (
            <div style={{ ...activeBtnStyle, background: '#0cd60c' }} />
          ) : (
            <div style={{ ...activeBtnStyle, background: '#ffc107' }} />
          )}
        </div>
        <div onClick={onExternalAtaRemove}>
          <img
            className="actions-icon"
            style={{
              height: '20px',
            }}
            src={remove}
            alt="remove"
          />
        </div>
      </div>

      <div className="obiLabel">External FXS</div>
      <div className="obiInfo">
        <div className="infoLabel">
          <FontAwesomeIcon fixedWidth className="labelIcon" icon="microchip" />
          <h5>MAC Address</h5>
        </div>
        <span>{boxDetails?.externalAta[0]?.macAddress}</span>
      </div>
    </div>
  );
};

export default ExternalAta;
